document.documentElement.classList.remove('no-js');

const searchToggle = document.querySelector('[data-search-toggle]');
const searchPanel = document.querySelector('[data-search-panel]');
const searchClose = document.querySelector('[data-search-close]');
const searchInput = document.querySelector('[data-predictive-input]');
const searchResults = document.querySelector('[data-predictive-results]');
const predictiveForm = document.querySelector('[data-predictive-form]');
let searchTimer;
let searchRequest;

const setSearchOpen = (open) => {
  if (!searchToggle || !searchPanel) return;
  searchToggle.setAttribute('aria-expanded', String(open));
  searchPanel.hidden = !open;
  document.body.classList.toggle('search-open', open);
  if (open) {
    document.querySelector('.site-nav')?.classList.remove('is-open');
    document.querySelector('.mobile-toggle')?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    window.setTimeout(() => searchInput?.focus(), 20);
  }
};

const showSearchMessage = (message) => {
  if (!searchResults) return;
  const status = document.createElement('p');
  status.className = 'header-search-status';
  status.textContent = message;
  searchResults.replaceChildren(status);
};

const renderSearchProducts = (products, query) => {
  if (!searchResults) return;
  if (!products.length) {
    showSearchMessage(`No products found for “${query}”.`);
    return;
  }
  const fragment = document.createDocumentFragment();
  products.forEach((product) => {
    const link = document.createElement('a');
    link.className = 'header-search-result';
    link.href = product.url || `${window.Shopify?.routes?.root || '/'}products/${product.handle}`;
    const imageUrl = product.featured_image?.url
      || (typeof product.featured_image === 'string' ? product.featured_image : null)
      || (typeof product.image === 'string' ? product.image : product.image?.url)
      || product.images?.[0]?.src;
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = product.featured_image?.alt || product.title;
      image.loading = 'lazy';
      link.append(image);
    } else {
      link.classList.add('header-search-result--no-image');
    }
    const copy = document.createElement('span');
    const title = document.createElement('strong');
    title.textContent = product.title;
    copy.append(title);
    const productPrice = product.price || product.variants?.[0]?.price;
    if (productPrice) {
      const price = document.createElement('small');
      const numericPrice = Number(productPrice);
      price.textContent = Number.isFinite(numericPrice)
        ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(numericPrice)
        : productPrice;
      copy.append(price);
    }
    link.append(copy);
    fragment.append(link);
  });
  searchResults.replaceChildren(fragment);
};

const requestPredictiveSearch = async (query) => {
  searchRequest?.abort();
  if (query.length < 2) {
    searchResults?.replaceChildren();
    return;
  }
  searchRequest = new AbortController();
  showSearchMessage('Searching…');
  const root = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams({
    q: query,
    'resources[type]': 'product',
    'resources[limit]': '4',
    'resources[options][fields]': 'title,product_type,tag,variants.title,vendor,body',
    'resources[options][unavailable_products]': 'last'
  });
  try {
    const normalizedQuery = query.toLowerCase();
    const categoryAliases = {
      police: ['police', 'law enforcement', 'officer'],
      fire: ['fire', 'firefighter', 'fire department']
    };
    const categoryHandle = Object.entries(categoryAliases).find(([, aliases]) => aliases.some((alias) => normalizedQuery.includes(alias)))?.[0];
    const predictiveRequest = fetch(`${root}search/suggest.json?${params}`, { signal: searchRequest.signal })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('Predictive search failed')));
    const collectionRequest = categoryHandle
      ? fetch(`${root}collections/${categoryHandle}/products.json?limit=4`, { signal: searchRequest.signal })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error('Collection search failed')))
      : Promise.resolve({ products: [] });
    const [predictiveResult, collectionResult] = await Promise.allSettled([predictiveRequest, collectionRequest]);
    const predictiveProducts = predictiveResult.status === 'fulfilled'
      ? predictiveResult.value.resources?.results?.products || []
      : [];
    const collectionProducts = collectionResult.status === 'fulfilled' ? collectionResult.value.products || [] : [];
    renderSearchProducts(predictiveProducts.length ? predictiveProducts : collectionProducts, query);
  } catch (error) {
    if (error.name !== 'AbortError') showSearchMessage('Search is temporarily unavailable.');
  }
};

searchToggle?.addEventListener('click', () => setSearchOpen(searchToggle.getAttribute('aria-expanded') !== 'true'));
searchClose?.addEventListener('click', () => setSearchOpen(false));
searchInput?.addEventListener('input', () => {
  window.clearTimeout(searchTimer);
  const query = searchInput.value.trim();
  searchTimer = window.setTimeout(() => requestPredictiveSearch(query), 180);
});
predictiveForm?.addEventListener('submit', (event) => {
  if (!searchInput?.value.trim()) event.preventDefault();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && searchPanel && !searchPanel.hidden) setSearchOpen(false);
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.mobile-toggle');
  if (toggle) {
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('is-open', !open);
    document.body.classList.toggle('menu-open', !open);
    return;
  }

  if (searchPanel && !searchPanel.hidden && !event.target.closest('[data-search-panel]') && !event.target.closest('[data-search-toggle]')) {
    setSearchOpen(false);
  }

  if (event.target.closest('.site-nav a')) {
    const nav = event.target.closest('.site-nav');
    nav?.classList.remove('is-open');
    document.querySelector('.mobile-toggle')?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  }
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const media = [...gallery.querySelectorAll('[data-media-id]')];
  const thumbs = [...gallery.querySelectorAll('[data-media-target]')];
  const currentLabel = gallery.querySelector('[data-gallery-current]');
  let current = Math.max(0, media.findIndex((item) => !item.hidden));

  const show = (next) => {
    if (!media.length) return;
    current = (next + media.length) % media.length;
    media.forEach((item, index) => {
      item.hidden = index !== current;
      if (index !== current) item.querySelectorAll('video').forEach((video) => video.pause());
    });
    thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === current)));
    if (currentLabel) currentLabel.textContent = String(current + 1);
  };

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
  gallery.showMediaById = (id) => {
    const index = media.findIndex((item) => String(item.dataset.mediaId) === String(id));
    if (index >= 0) show(index);
  };

  let touchStart = 0;
  gallery.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
  gallery.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStart;
    if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
  }, { passive: true });
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const json = section.querySelector('[data-product-json]');
  if (!json) return;
  const variants = JSON.parse(json.textContent);
  const radios = section.querySelectorAll('.variant-group input');
  const idInput = section.querySelector('[data-variant-id]');
  const price = section.querySelector('[data-price]');
  const mobilePrice = section.querySelector('[data-mobile-price]');
  const comparePrice = section.querySelector('[data-compare-price]');
  const buttons = section.querySelectorAll('.buy-button');
  const buttonText = section.querySelectorAll('[data-add-text]');
  const gallery = section.querySelector('[data-product-gallery]');
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);

  const update = () => {
    const selected = [...section.querySelectorAll('.variant-group')].map((group) => group.querySelector('input:checked')?.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
    if (!variant) return;
    idInput.value = variant.id;
    price.textContent = formatMoney(variant.price);
    if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);
    if (comparePrice) {
      comparePrice.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      comparePrice.hidden = !(variant.compare_at_price > variant.price);
    }
    buttons.forEach((button) => { button.disabled = !variant.available; });
    buttonText.forEach((text) => { text.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT'; });
    if (variant.featured_media?.id) gallery?.showMediaById?.(variant.featured_media.id);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
  };
  radios.forEach((radio) => radio.addEventListener('change', update));

  const dialog = section.querySelector('[data-size-guide-dialog]');
  section.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => dialog?.showModal?.()));
  section.querySelector('[data-size-guide-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
});

document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
  if (!section.dataset.url) return;
  try {
    const response = await fetch(section.dataset.url);
    if (!response.ok) return;
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector('[data-product-recommendations]');
    if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
  } catch (error) {
    // Recommendations are optional; leave the section empty if Shopify cannot return them.
  }
});

const filterPanel = document.querySelector('#CollectionFilters');
const filterToggle = document.querySelector('[data-filter-toggle]');
filterToggle?.addEventListener('click', () => {
  const open = filterPanel?.classList.toggle('is-open');
  filterToggle.setAttribute('aria-expanded', String(Boolean(open)));
  document.body.classList.toggle('filters-open', Boolean(open));
});
document.querySelector('[data-filter-close]')?.addEventListener('click', () => {
  filterPanel?.classList.remove('is-open');
  filterToggle?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('filters-open');
});

if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const revealItems = document.querySelectorAll('.section-pad, .mission-split, .newsletter');
  revealItems.forEach((item) => item.classList.add('reveal-ready'));
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    }
  }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  revealItems.forEach((item) => observer.observe(item));
}
